<div class="address-container">
  
  <label>{{label}}</label>
  
  <!-- If we are using an address line 1 and 2, display with adjusted labels -->
  @if(streetAddress2Control) {
    <app-text-input label="Address line 1" [control]="addressForm.controls.streetAddress">
    </app-text-input>
    <app-text-input label="Address line 2" [control]="streetAddress2Control">
    </app-text-input>
  }
  @else {
    <app-text-input label="Street Address" [control]="addressForm.controls.streetAddress">
    </app-text-input>
  }

  @if(suburbControl) {
    <app-text-input label="Suburb" [control]="suburbControl">
    </app-text-input>
  }
  

  <app-text-input label="City" [control]="addressForm.controls.city">
  </app-text-input>

  <app-text-input label="State" [control]="addressForm.controls.state">
  </app-text-input>

  <app-text-input label="Postcode" [control]="addressForm.controls.postcode">
  </app-text-input>

  <app-text-input label="Country" [control]="addressForm.controls.country">
  </app-text-input>

</div>